<div class="modal-dialog" role="document">
    <div class="modal-content">
        <div class="modal-header">
            <h2 class="modal-title" translate>LABEL.OTP_AUTHENTICATION</h2>
            <button type="button" class="btn-close" (click)="close(false)" data-bs-dismiss="modal"
                    aria-label="Close"></button>
        </div>
        <form name="otpAuthForm" #tplForm="ngForm">
            <div class="modal-body">
                <div class="form-floating">
                    <input
                        id="otpAuthPassword"
                        [type]="showPassword ? 'text' : 'password'"
                        autocomplete="current-password"
                        class="form-control"
                        placeholder="Password"
                        ngModel
                        name="otpAuthPassword"
                    />
                    <label for="otpAuthPassword" translate>LABEL.PASSWORD</label>
                    <validation-error class="invalid-feedback" for="otpAuthPassword"/>
                </div>
            </div>
            <div class="modal-footer justify-content-center">
                <button type="button"
                        class="btn btn-secondary"
                        data-bs-dismiss="modal"
                        (click)="close(false)"
                        translate>BUTTON.CANCEL
                </button>
                <button class="btn btn-primary"
                        data-bs-dismiss="modal"
                        type="submit"
                        (onValid)="submit($event)"
                        [disabled]="tplForm.disabled"
                        translate>BUTTON.CONTINUE
                </button>
            </div>
        </form>

    </div>
</div>
